/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import { types } from "./actions";

const initialState = {
  list: [],
  error: null,
  loading: false,
  loaded: false,
  total: 0,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_ANALYTICS: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case types.FETCH_ANALYTICS_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        list: action.payload,
      };
    }
    case types.FETCH_ANALYTICS_FAILED: {
      /* istanbul ignore next */
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload,
      };
    }

    case types.FETCH_A_ANALYTIC: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case types.FETCH_A_ANALYTIC_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        entities: {
          ...state.entities,
          [action.payload.playerId]: action.payload,
        },
      };
    }
    case types.FETCH_A_ANALYTIC_FAILED: {
      /* istanbul ignore next */
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload,
      };
    }

    default:
      return state;
  }
}
